import { Component, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from './services/authorization/auth.service';
import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  NavigationStart,
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import {
  AccountInfo,
  AuthenticationResult,
  EndSessionRequest,
} from '@azure/msal-browser';
import {
  APP_NAME,
  LS_IS_LOGOUT_ACTION,
  LS_REDIRECT_URL,
} from './constants/app.constant';
import { UrlUtilService } from './services/common/url-util.service';
import { Location } from '@angular/common';
import { StringUtilService } from './services/common/string-util.service';
import { Title } from '@angular/platform-browser';
import { AccountService } from './api/auth/services/account/account.service';
import Swal from 'sweetalert2';
import { CommonService } from './services/common/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  userActivity: any;
  userInactive: Subject<any> = new Subject();

  constructor(
    private authService: AuthService,
    private _router: Router,
    private msalService: MsalService,
    private location: Location,
    private urlUtil: UrlUtilService,
    private stringUtil: StringUtilService,
    private titleService: Title,
    private accountService: AccountService,
    private common: CommonService
  ) {
    this.titleService.setTitle(APP_NAME);
    this.setTimeout();
    this.userInactive.subscribe(() => {});
    this.secureUrl();
  }

  setTimeout() {
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      1000
    );
  }

  setLastActivity() {
    this.authService.manageLastActivity();
  }

  @HostListener('window:keydown') refreshUserStateByKeyDown() {
    if (this.common.getLocalStorage(LS_IS_LOGOUT_ACTION) === 'true') {
      localStorage.removeItem(LS_IS_LOGOUT_ACTION);
      return;
    }
    this.setLastActivity();
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('window:click', ['$event']) refreshUserStateByClick(
    event: any
  ) {
    this.setLastActivity();
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  async ngOnInit() {
    if (!this.authService.userRoleDev) {
      this.authService.userRoleDev = 'SCG';
    }
    this.msalService.instance = this.authService.getMSALInstanceFactory();
    await this.msalService.instance.initialize();
    await this.msalService.handleRedirectObservable().subscribe({
      next: (response: AuthenticationResult) => {
        if (response != null && response.account != null) {
          this.authService.setUpStorageAfterLogin(response);
        }
        setTimeout(() => {
          if (response != null && response.account != null) {
            let firstName = '';
            let lastName = '';
            if (response.account.name?.indexOf(',') !== -1) {
              firstName = response.account.name?.split(',')[1].trim() ?? '';
              lastName = response.account.name?.split(',')[0].trim() ?? '';
            } else if (response.account.name?.indexOf(' ') !== -1) {
              firstName = response.account.name?.split(' ')[1].trim() ?? '';
              lastName = response.account.name?.split(' ')[0].trim() ?? '';
            } else {
              firstName = response.account.name!;
            }
            this.accountService
              .getAccount({
                email: response.account.username,
                firstName: firstName,
                lastName: lastName,
                userId: response.account.username,
              })
              .subscribe(
                (result) => {
                  if (
                    result.groups.length === 0 ||
                    result.roles.length === 0 ||
                    result.menu.length === 0
                  ) {
                    this.authService.signOut();
                    Swal.fire({
                      icon: 'error',
                      title: 'Unauthorized',
                      html: 'No Authorize, Please contact <br>Sales Representative or Customer Service.',
                    });
                    return;
                  } else {
                    this.authService.appTokenApi = result.appToken;
                    this.authService.userMenu = result.menu;
                    this.authService.userRole = result.roles;
                    this.authService.userDetail = result.userDetail;
                    this.authService.userGroup = result.groups;
                    setTimeout(() => {
                      if (response.account != null) {
                        this.setLastActivity();
                        this.manageMsalLogin(response.account);
                      }
                    }, 100);
                  }
                },
                (err) => {
                  // SIT no 50
                  // this.forceLogOut();
                  this.authService.signOut();
                }
              );
            // this.authService.generateAppToken(response);
            // this.authService.setCurrentUser(response.account);
            // this.authService.setActiveAccount(response.account);
          }
        });
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  manageMsalLogin(account: AccountInfo) {
    // Does not work with hash within url
    // const redirectURL =
    //     this._activatedRoute.snapshot.queryParamMap.get(
    //         'redirectURL'
    //     ) || '/home';
    var currentURLwithoutHash = window.location.href.replace('/#/', '/');
    var searchUrl = new URLSearchParams(new URL(currentURLwithoutHash).search);
    const redirectURL = searchUrl.get(LS_REDIRECT_URL) || '/home';

    this.authService.setActiveAccount(account);

    // Navigate to the redirect url
    this._router.navigateByUrl(redirectURL);
  }

  logout(): void {
    this.authService.signOut();
    this.authService.signOutMsal();
    this._router.navigate(['sign-in']);
  }

  // force to go to logout page, so next time user will be able to select new account
  async forceLogOut() {
    this.authService.signOut();
    this.msalService.instance = this.authService.getMSALInstanceFactory();
    await this.msalService.instance.initialize();
    await this.msalService.instance
      .logout({
        ...this.authService.getMSALGuardConfigFactory().authRequest,
      } as EndSessionRequest)
      .then(() => {
        this._router.navigate(['sign-in']);
      });
  }

  secureUrl() {
    this._router.events.subscribe((res) => {
      var event = res;
      if (event instanceof NavigationStart) {
        //console.log("NavigationStart");
        // this.isShowWebInfoBtn = false;
        // this.isShowAppDialog = false;
        // this.showWebAlert('');
        if (
          !event.url.startsWith('/error') &&
          !event.url.startsWith('/sign-in') &&
          !event.url.startsWith('/sign-out') &&
          !event.url.startsWith('/contact-point')
        ) {
          // this.showWebBlockAlert('');
        }
        let url = event.url;
        let indexOfQueryParams = url.indexOf('?queryParams=');
        if (indexOfQueryParams > 0) {
          let newUrl = url.replace('?queryParams=', '');
          this._router.navigateByUrl(newUrl);
        }
      }
      // debugger;
      if (event instanceof NavigationEnd) {
        //console.log("NavigationEnd");
        //if have param
        let url = event.url;
        let urlDecrypt = '';

        // let indexParamType = 0;
        // let indexOfSemiColon = url.indexOf(';');
        // let indexOfQuestion = url.indexOf('?');

        // let paramtype = null;
        // if (indexOfSemiColon > 0) {
        //   indexParamType = indexOfSemiColon;
        //   paramtype = ';';
        // } else if (indexOfQuestion > 0) {
        //   indexParamType = indexOfQuestion;
        //   paramtype = '?';
        // }
        // let state = url;
        // if (paramtype) {
        //   state = url.substring(0, indexParamType + 1);
        //   let urlParam = url.substring(indexParamType + 1);

        //   let urlParamDecode = decodeURIComponent(urlParam);
        //   if (urlParamDecode.startsWith('{{')) {
        //     let newUrl = this.urlUtil.decryptUrl(url, paramtype);
        //     urlDecrypt = newUrl;
        //     this._router.navigateByUrl(newUrl);
        //   } else {
        //     //if have variable , encrypt;
        //     let newUrl = this.urlUtil.encryptUrl(url, paramtype);
        //     urlDecrypt = url;
        //     this.location.replaceState(newUrl);
        //   }
        // } else {
        //   state = event.urlAfterRedirects;
        // }

        // let cfState = this.getStateConfig(state);
        // this.showWebAlert(cfState);
        // this.showPageInfo(cfState);
        // this.showWebBlockAlert(cfState);
      }

      // if (event instanceof NavigationError) {
      //     // Hide loading indicator
      //     console.log("NavigationError");
      // }
    });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    document.body.appendChild(script);
    return script;
  }

  getStateConfig(urlState: string) {
    let state = this.stringUtil.replaceAll(urlState, ';', '');
    state = this.stringUtil.replaceAll(state, '/', '_');
    state = this.stringUtil.replaceAll(state, '-', '_');
    return state;
  }

  // showPageInfo(state : string){
  //   this.webInfoContent = this.appService.getWebInfo(state);
  //   if(this.webInfoContent){
  //     this.isShowWebInfoBtn = true;
  //   }
  //   else{
  //     this.isShowWebInfoBtn = false;
  //   }
  // }

  // showWebAlert(state : string){
  //   let webAlertContent = this.appService.getWebAlert(state);
  //   if(webAlertContent){
  //     this.appDialogData.header = 'Alert!';
  //     this.appDialogData.position = 'top';
  //     this.appDialogData.content = webAlertContent;
  //     this.appDialogData.isModal = true;
  //     this.isShowAppDialog = true;
  //   }
  // }

  // showWebBlockAlert(state : string){
  //   let webAlertContent = this.appService.getWebBlockAlert(state);
  //   if(webAlertContent){
  //     this._router.navigate(["/error",{code : 503 , msg : webAlertContent}]);
  //   }
  // }
}
